import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Dot = styled.div`
  position: fixed;
  pointer-events: none;
  width: 15px;
  height: 15px;
  background: ${props => props.color};
  border-radius: 50%;
  z-index: 9999;
  mix-blend-mode: difference;
  box-shadow: 0 0 10px ${props => props.color};
  will-change: transform;
  transition: background 0.3s ease, box-shadow 0.3s ease;
`;

const colors = {
  blue: 'rgba(12, 33, 152, 0.7)',
  red: 'rgba(215, 29, 32, 0.7)'
};

const MouseDot = () => {
  const dotRef = useRef(null);
  const positionRef = useRef({ x: 0, y: 0 });
  const velocityRef = useRef({ x: 0, y: 0 });
  const currentPositionRef = useRef({ x: 0, y: 0 });
  const requestRef = useRef();
  const [dotColor, setDotColor] = useState(colors.blue);

  const springConfig = {
    stiffness: 0.15,
    damping: 0.8,
    mass: 1
  };

  useEffect(() => {
    // Color change timer
    const colorChangeInterval = setInterval(() => {
      setDotColor(prev => prev === colors.blue ? colors.red : colors.blue);
    }, 2000); // Changes color every 2 seconds

    return () => clearInterval(colorChangeInterval);
  }, []);

  const animate = () => {
    const dot = dotRef.current;
    if (dot) {
      // Spring physics calculation
      const dx = positionRef.current.x - currentPositionRef.current.x;
      const dy = positionRef.current.y - currentPositionRef.current.y;

      const ax = (dx * springConfig.stiffness) - (velocityRef.current.x * springConfig.damping);
      const ay = (dy * springConfig.stiffness) - (velocityRef.current.y * springConfig.damping);

      velocityRef.current.x += ax / springConfig.mass;
      velocityRef.current.y += ay / springConfig.mass;

      currentPositionRef.current.x += velocityRef.current.x;
      currentPositionRef.current.y += velocityRef.current.y;

      dot.style.transform = `translate(${currentPositionRef.current.x}px, ${currentPositionRef.current.y}px)`;
    }
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      positionRef.current = {
        x: e.clientX,
        y: e.clientY
      };
    };

    requestRef.current = requestAnimationFrame(animate);
    window.addEventListener('mousemove', handleMouseMove, { passive: true });

    return () => {
      cancelAnimationFrame(requestRef.current);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return <Dot ref={dotRef} color={dotColor} />;
};

export default MouseDot; 